/**
 * Wire types for the public website support chatbot (Step 16).
 *
 * Deliberately tiny: a visitor sends their conversation so far (the server
 * keeps no state) and gets back one reply. There is no organization id, user
 * id, session or any other identifier in either direction -- the chatbot has
 * no concept of a customer.
 */
export type SupportChatRole = "user" | "assistant";

export interface SupportChatMessage {
  role: SupportChatRole;
  content: string;
}

export interface SupportChatRequest {
  /** Conversation so far, oldest first; the last entry must be a user message. */
  messages: SupportChatMessage[];
}

export interface SupportChatResponse {
  reply: string;
  requestId: string;
}

/** Limits shared by the widget (to size its input) and the API (to enforce). */
export const SUPPORT_CHAT_LIMITS = {
  maxMessages: 12,
  maxUserMessageChars: 500,
  maxAssistantMessageChars: 1500,
  maxTotalChars: 4000,
} as const;
